import { serverUrl } from "@/config/default";
import { predict } from "@/functions/checker/predict";
import { dataWriter } from "@/functions/data";
import { selectTab } from "@/state/functions";
import { RootState } from "@/state/reducer";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const Greeting = () => {
  const State = useSelector((state: RootState) => state);
  const [auth, setAuth] = useState(false);
  const dispatch = useDispatch();

  const startTest = () => {
    dataWriter.startMouseTracker();
    selectTab("step1");
  };

  useEffect(() => {
    Promise.all([
      predict("This is a meaningful sentence."),
      predict("Fiva fvaprvapr kjdngf kjrngrkvm."),
      predict("All your base are belong to us."),
    ]).then((res) => {
      console.log("Tests:", res, "expected:", [1, 0, 1]);
    });
  }, []);

  // ⬇️ Загрузка Telegram Login Widget
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    script.setAttribute("data-telegram-login", "uniworkdatabot"); // ⚠️ без @
    script.setAttribute("data-size", "large");
    script.setAttribute("data-userpic", "true");
    script.setAttribute("data-radius", "12");
    script.setAttribute("data-request-access", "write");
    script.setAttribute("data-onauth", "onTelegramAuth(user)");

    document.getElementById("telegram-login")?.appendChild(script);

    // глобальный обработчик
    (window as any).onTelegramAuth = (user: any) => {
      console.log("Telegram user:", user);

      // пример отправки на бэкенд
      fetch(`${serverUrl}auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            console.log("Error:", data.error);
            return;
          }

          // 1️⃣ сохраним токен в переменную
          const token = data.token;

          console.log("Token received:", token);
          localStorage.setItem("token", token);
          // 2️⃣ проверка токена, запрос к /isauth
          return fetch(`${serverUrl}isauth`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`, // токен добавляем в заголовок
            },
          });
        })
        .then((res) => (res ? res.json() : { error: "Invalid res" }))
        .then((data) => {
          console.log("/isauth response:", data);
          if (!data.error) {
            setAuth(true);
          }
        })
        .catch((err) => console.error(err));
    };
  }, []);

  return (
    <div className="page greeting gridCenter w100 h100">
      <div className="inner columnCenter gap24">
        <h1>Тест когнитивных способностей</h1>

        {/* Telegram login */}
        <div id="telegram-login" />

        {auth && <div className="btn mainBtn" onClick={startTest}>
          Начать тест
        </div>}
      </div>
    </div>
  );
};

export default Greeting;
